export default "__VITE_ASSET__BxuQHN1X__"